import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
    name: "login",
    initialState: () => {
        const token = localStorage.getItem('token');
        if (!token) {
            return {
                isLog: false,
                token: null,
                eu_ba_phone: null,
                eu_ba_id: null,
                eu_name: null,
                eu_role: null,
                e_id: null,
                e_name: null,
                ed_id: null,
                ed_name: null,
                eu_id: null,
                expirationTime: 0,
                ess_menu_id: null,
                ess_name: null,
                eu_dept_id: null,
            }
        }

        const safeParse = (key) => {
            try {
                const value = localStorage.getItem(key);
                return value ? JSON.parse(value) : null;
            } catch {
                return null;
            }
        };

        return {
            isLog: true,
            token,
            eu_ba_phone: safeParse('eu_ba_phone'),
            eu_ba_id: safeParse('eu_ba_id'),
            eu_name: safeParse('eu_name'),
            eu_role: safeParse('eu_role'),
            e_id: safeParse('e_id'),
            e_name: safeParse('e_name'),
            ed_id: safeParse('ed_id'),
            ed_name: safeParse('ed_name'),
            eu_id: safeParse('eu_id'),
            expirationTime: +(safeParse('expirationTime') || 0),
            ess_menu_id: safeParse('e_id') === '1' ? safeParse('ess_menu_id') : "",
            ess_name: safeParse('e_id') === '1' ? safeParse('ess_name') : "",
            eu_dept_id: safeParse('eu_dept_id'),
        }
    },
    reducers: {
        setLogin(state, action) {
            state.isLog = true;
            state.token = action.payload.token;
            state.eu_ba_phone = action.payload.eu_ba_phone;
            state.eu_ba_id = action.payload.eu_ba_id;
            state.eu_name = action.payload.eu_name;
            state.eu_role = action.payload.eu_role;
            state.e_id = action.payload.e_id;
            state.e_name = action.payload.e_name;
            state.ed_id = action.payload.ed_id;
            state.ed_name = action.payload.ed_name;
            state.eu_id = action.payload.eu_id;
            state.ess_menu_id = action.payload.ess_menu_id;
            state.ess_name = action.payload.ess_name;
            state.eu_dept_id = action.payload.eu_dept_id;
            
            const currentTime = Date.now();
            const timeout = 1000 * 60 * 60 * 24 * 30;
            state.expirationTime = currentTime + timeout;
            
            localStorage.setItem('token', state.token);
            localStorage.setItem('eu_ba_phone', JSON.stringify(state.eu_ba_phone));
            localStorage.setItem('eu_ba_id', JSON.stringify(state.eu_ba_id));
            localStorage.setItem('eu_name', JSON.stringify(state.eu_name));
            localStorage.setItem('eu_role', JSON.stringify(state.eu_role));
            localStorage.setItem('e_id', JSON.stringify(state.e_id));
            localStorage.setItem('e_name', JSON.stringify(state.e_name));
            localStorage.setItem('ed_id', JSON.stringify(state.ed_id));
            localStorage.setItem('ed_name', JSON.stringify(state.ed_name));
            localStorage.setItem('eu_id', JSON.stringify(state.eu_id));
            localStorage.setItem('expirationTime', JSON.stringify(state.expirationTime));
            localStorage.setItem('ess_menu_id', JSON.stringify(state.ess_menu_id));
            localStorage.setItem('ess_name', JSON.stringify(state.ess_name));
            localStorage.setItem('eu_dept_id', JSON.stringify(state.eu_dept_id));
        },
        setLogout(state, action) {
            state.isLog = false;
            state.token = null;
            localStorage.removeItem('token');
            localStorage.removeItem('expirationTime');
            if (!state.isRemeberUser) {
                localStorage.removeItem('eu_ba_id');
                localStorage.removeItem('eu_name');
                localStorage.removeItem('eu_role');                
                localStorage.removeItem('e_id');                
                localStorage.removeItem('e_name');                
                localStorage.removeItem('ed_id');                
                localStorage.removeItem('eu_id');                
                localStorage.removeItem('ed_name');                
                localStorage.removeItem('ess_menu_id');                
                localStorage.removeItem('ess_name');                
                localStorage.removeItem('eu_dept_id');                
            }
        }        
    }
})

export const { setLogin, setLogout } = loginSlice.actions;
export const { reducer: loginReducer } = loginSlice;